import { useAnalytics, withEventContext } from "@codat/analytics";
import { Card, Modal, Typography } from "@codat/orchard-ui";
import { ConfigStatusType, useConfig } from "contexts/ConfigContext";
import { useEffect, useState } from "react";
import { useWindow } from "utils";

import Button from "components/Button";

import styles from "./MobileWarningOverlay.module.css";

const key = "mobile-warning-dismissed";

const MobileWarningOverlayContent: React.FC = () => {
  const { window } = useWindow();
  const analytics = useAnalytics();
  const config = useConfig();

  const [isDismissed, setDismissedState] = useState(
    window.sessionStorage.getItem(key) === "true"
  );

  const setDismissed = () => {
    window.sessionStorage.setItem(key, "true");
    setDismissedState(true);
  };

  const [width, setWidth] = useState(window.innerWidth);

  const configured =
    (config.state.status === ConfigStatusType.READY &&
      config.state.data.showMobileWarning) ??
    false;

  useEffect(() => {
    const updateDimensions = () => {
      setWidth(window.innerWidth);
    };

    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, [window]);

  const isMobile = width < 768;

  const onClose = () => {
    setDismissed();
    analytics.sendEvent("Modal dismissed");
  };

  return isMobile && configured && !isDismissed ? (
    <Modal onClose={onClose} focusTrapOptions={{ disabled: true }}>
      <>
        {/* 
          Currently have issues with focus trap causing the 'click off' interaction for the modals
          to not work on mobile. This empty div is used as a work around.

          https://dev.azure.com/codat/Codat/_workitems/edit/41594
        */}
        <div
          className={styles.mobileClickOffWorkaroundWrapper}
          onClick={onClose}
        ></div>
        <Card className={styles.card} data-testid="mobile-warning">
          <Typography as="p" variant="heading_xl">
            This flow is not optimized for mobile devices.
          </Typography>
          <Typography as="p">
            Some of our integrations aren&apos;t optimized for mobile devices.
            For the best experience, use a desktop, laptop, or tablet device.
          </Typography>
          <Button
            analyticsName="Continue anyway"
            className={styles.continueButton}
            label="Continue anyway"
            variant="secondary"
            color="interface"
            onClick={onClose}
          />
        </Card>
      </>
    </Modal>
  ) : (
    <></>
  );
};

export const MobileWarningOverlay = withEventContext(
  MobileWarningOverlayContent,
  "Mobile support modal"
);
